import { Button, Card, Col, Modal, notification, Row } from 'antd';
import { useEffect } from 'react';
import { setHeaderName } from '../../services/SetHeaderName';
import './style/UserProfile.scss'
import arm from '../../assets/icons/arms.png'
import { CheckCircleOutlined } from '@ant-design/icons';
import { getUserProfileDetailsApi } from '../../config/Api';
import { useState } from 'react';
import { ResetPassword } from './components/ResetPassword';
import { EditUserDetail } from './components/EditUserDetail';

import { UpgradePlanNotice } from "../Billing/UpgradePlanNotice";
import { PlanHistory } from "../Billing/PlanHistory";
import { Link } from "react-router-dom";
import { readCookie } from "../../config/CookieScript";
import { ADMIN_ROLE, ROLE_KEYWORD } from "../../config/constant";
export const UserProfile = () => {

    const [userData, setUserData] = useState()
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [userDetailModalVisible, setUserDetailModalVisible] = useState(false)

    const getUserProfileDetails = () => {
        let userId = localStorage.getItem('id')
        getUserProfileDetailsApi(userId)
            .then((res) => {
                if (res.status === 200) {
                    setUserData(res.data.data);
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }


    useEffect(() => {
        getUserProfileDetails()
        setHeaderName('Profile')
    }, []);

    const handleOk = () => {
        setIsModalVisible(false);
    };
    const handleCancel = () => {
        setIsModalVisible(false);
    };
    const handleUserModal = () => {
        setUserDetailModalVisible(false);
    };
    return (
        <>
            <div className="UserProfile">
                <UpgradePlanNotice always className="mb-3 mx-2" />
                <Row className='UserProfileDetail' gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]}>

                    {/* <Col xl={{ offset: 6, span: 14 }}> */}
                    <Col xs={24} sm={24} md={11} lg={11} xl={11} xxl={11} className="ms-4">
                        <Row gutter={[24, { xs: 8, sm: 16, md: 24, lg: 8 }]} className="userData rounded pb-2">
                            <Col xl={24} className="heading">
                                <h4 className='mb-0 py-1'>Account Info</h4>
                            </Col>
                            <Col xs={24} md={12} xl={11} xxl={24} className="text-center my-2">
                                <img src={arm} width={150} />
                            </Col>
                            <Col xs={24} md={12} xl={11} xxl={12}>
                                <h5>Name : </h5>
                                <h6>{userData?.name || ''}</h6>
                            </Col>
                            <Col xs={24} md={12} xl={11} xxl={12}>
                                <h5>Email is ( Verified ) : <CheckCircleOutlined color='green' /> </h5>
                                <h6>{userData?.email || ''}</h6>
                            </Col>
                            <Col xs={24} md={12} xl={11} xxl={12}>
                                <h5>Phone </h5>
                                <h6>{userData?.phone || ''}</h6>
                            </Col>
                            <Col xs={24} md={12} xl={11} xxl={12}>
                                <h5>Address </h5>
                                <h6> &quot;Harikrishna Nivas&quot;, 5-Gopal nagar, Opp. andhmahila vikas gruh, Dhebar road south. Rajkot 360002</h6>
                            </Col>
                            <Col xs={24} md={12} xl={11} xxl={24} className="text-center">
                                <Button htmlType="submit" className="submit-button b-0 rounded me-2"
                                    onClick={() => { setUserDetailModalVisible(true) }}>
                                    EDIT
                                </Button>
                                <Button htmlType="submit" className="reset-button b-0 rounded"
                                    onClick={() => { setIsModalVisible(true) }}>
                                    Reset Password
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    {/* <Col xl={1} /> */}
                    {/* <Col xl={{ offset: 6, span: 14 }} className="mt-3"> */}
                    <Col xs={24} sm={24} md={11} lg={11} xl={11} xxl={11} className='ms-4'>
                        <Row gutter={[24, { xs: 8, sm: 16, md: 24, lg: 24 }]} className="userData rounded pb-2">
                            <Col xl={24} className="heading">
                                <h4 className='mb-0 py-1'>Company Info</h4>
                            </Col>
                            <Col xs={24} md={12} xl={11} xxl={12}>
                                <h5>Company Name : </h5>
                                <h6>Mansi Bhojani</h6>
                            </Col>
                            <Col xs={24} md={12} xl={11} xxl={12}>
                                <h5>Company Address </h5>
                                <h6>&quot;Harikrishna Nivas&quot;, 5-Gopal nagar, Opp. andhmahila vikas gruh, Dhebar road south. Rajkot 360002</h6>
                            </Col>
                            <Col xs={24} md={12} xl={11} xxl={12}>
                                <h5>Company URL : </h5>
                                <h6>mansi.hbhojani@gmail.com</h6>
                            </Col>
                            <Col xs={24} md={12} xl={11} xxl={12}>
                                <h5>From Email(Your emails will be sent from this email) </h5>
                                <h6>mansi.hbhojani@gmail.com</h6>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {/* every plan the doctor has had, Free included (admins have none) */}
                {readCookie(ROLE_KEYWORD) !== ADMIN_ROLE && (
                    <Card title="Plan history" className="mt-4 mx-2" extra={<Link to="/my-plan">My Plan</Link>}>
                        <PlanHistory />
                    </Card>
                )}
            </div>
            <Modal
                open={isModalVisible}
                centered
                footer={null}
                width={500}
                className="resetPasswordForm rounded"
                onOk={handleOk} onCancel={handleCancel}
            >
                <ResetPassword
                    setIsModalVisible={setIsModalVisible}
                />
            </Modal>


            <Modal
                open={userDetailModalVisible}
                centered
                footer={null}
                width={700}
                className="resetPasswordForm rounded"
                onOk={handleOk} onCancel={handleUserModal}
            >
                <EditUserDetail
                    setUserDetailModalVisible={setUserDetailModalVisible}
                    userData={userData}
                />
            </Modal>

        </>
    )
}
